import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MassCommParameterService } from 'src/app/communication/shared/mass-comm-parameter.service';
import { CommitteeMemberSearchDto } from 'src/app/committees/shared/dto/committee-member-search.dto';
import { ProfileAdvancedSearchParams } from 'src/app/profiles/search/profile-advanced-search-params.model';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { CommitteeMemberService } from 'src/app/committees/shared/committee-member.service';
import { UtilService, DialogService, TranslationService, DialogModal, NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-committee-member-search-actions',
  templateUrl: './committee-member-search-actions.component.html',
  styleUrls: ['./committee-member-search-actions.component.less'],
  providers: [MassCommParameterService],
    standalone: false
})
export class CommitteeMemberSearchActionsComponent implements OnInit {
  public actionsOptions: MenuItem[];

  @Input() searchParams: CommitteeMemberSearchDto;
  @Input() selectAll: boolean;
  @Input() selectedItems: Map<any, boolean> = new Map();
  @Input() selectedCount: number;
  @Input() totalCount: number;

  @Output() resultsUpdated: EventEmitter<any> = new EventEmitter();

  constructor(
    private _committeeMemberService: CommitteeMemberService,
    private _dialogService: DialogService,
    private _massCommParameterService: MassCommParameterService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _utilService: UtilService
  ) {}

  ngOnInit(): void {
    const emailLabel = this._translationService.getInstantTitlecase(
      'committees.edit.committee-members.actions-dropdown.email-selected-members'
    );
    const exportLabel = this._translationService.getInstantTitlecase(
      'committees.edit.committee-members.actions-dropdown.export-committee-members'
    );
    const deactivateLabel = this._translationService.getInstantTitlecase(
      'committees.edit.committee-members.actions-dropdown.deactivate-selected-members'
    );
    this.actionsOptions = [
      {
        label: emailLabel,
        command: (event) => {
          this.navigateToMassComm();
        },
      },
      {
        label: exportLabel,
        command: async (event) => {
          const csvUrl = await this._committeeMemberService.searchExportToCsv(this.searchParams);
          this._navigationService.popupSafeNavigate(csvUrl);
        },
      },
      {
        label: deactivateLabel,
        command: (event) => {
          this.bulkDeactivate();
        },
      },
    ];
  }

  bulkDeactivate() {
    const count = this.selectedCount > 0 ? this.selectedCount : this.totalCount;
    const dialog = new DialogModal();
    dialog.yesText = this._translationService
      .getInstant('committees.edit.committee-members.actions-dropdown.deactivate-members-button-label')
      .toUpperCase();
    dialog.noText = this._translationService.getInstant('common.cancel').toUpperCase();
    dialog.headerText = this._translationService.getInstantTitlecase(
      'committees.edit.committee-members.actions-dropdown.deactivate-selected-members'
    );
    dialog.messageText = this._translationService.getInstant(
      'committees.edit.committee-members.actions-dropdown.deactivate-members-prompt-message',
      {
        count,
      }
    );
    dialog.showCancel = false;
    dialog.show = true;
    dialog.yesFunction = () => {
      const selectedCommitteeMemberIds = [...this.selectedItems].filter((x) => x[1] === !this.selectAll).map((x) => x[0]);
      const searchParams = this._utilService.clone(this.searchParams);
      if (this.selectAll) {
        searchParams.ExcludeCommitteeMemberIds = selectedCommitteeMemberIds;
      } else {
        searchParams.CommitteeMemberIds = selectedCommitteeMemberIds;
      }
      this._committeeMemberService
        .bulkDeactivateCommitteeMembers(searchParams)
        .catch((err) => {
          this._notificationService.httpError(err);
        })
        .finally(() => {
          this.resultsUpdated.emit();
        });
    };
    this._dialogService.addDialog(dialog);
  }

  navigateToMassComm() {
    const profileSearchParams = new ProfileAdvancedSearchParams();
    profileSearchParams.CommitteeOptions.CommitteeIds = this.searchParams.CommitteeIds;
    profileSearchParams.CommitteeOptions.IncludeInactive = this.searchParams.IncludeInactive;
    profileSearchParams.CommitteeOptions.MemberSince = this.searchParams.MemberSince;
    profileSearchParams.CommitteeOptions.DateInactive = this.searchParams.DateInactive;

    const selectedCommitteeMemberIds = [...this.selectedItems].filter((x) => x[1] === !this.selectAll).map((x) => x[0]);
    if (this.selectAll) {
      profileSearchParams.CommitteeOptions.IgnoreCommitteeMemberIds = selectedCommitteeMemberIds;
    } else {
      profileSearchParams.CommitteeOptions.CommitteeMemberIds = selectedCommitteeMemberIds;
    }

    this._massCommParameterService.setProfileSearchParams(profileSearchParams);
    this._navigationService.navigateToCommunicationNewEmailMessage();
  }
}
